let gestureReceived = false;
let audioContext: AudioContext | undefined;
let gainNode: GainNode;
let oscillator: OscillatorNode | undefined;

const beepFrequency = 440;
const beepVolume = 0.2;
const silentVolume = 0;
const durationSeconds = 0.005;

export function playBeep() {
  if (!gestureReceived) {
    return;
  }

  if (audioContext === undefined) {
    audioContext = new AudioContext();

    // Create a single oscillator that runs continuously
    oscillator = audioContext.createOscillator();
    gainNode = audioContext.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(beepFrequency, audioContext.currentTime);

    // Start the oscillator and connect it to the gain node
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Start the oscillator running indefinitely
    oscillator.start();
  }

  if (audioContext.state === 'suspended') {
    audioContext.resume().catch((err: unknown) => {
      console.error('Failed to resume audio context:', err);
    });
  }

  // Set the gain to beep volume (make the sound audible)
  gainNode.gain.setValueAtTime(beepVolume, audioContext.currentTime);

  // Schedule the gain to drop to 0 (silent) after the beep duration
  gainNode.gain.setValueAtTime(silentVolume, audioContext.currentTime + durationSeconds);
}

function handleGesture() {
  gestureReceived = true;

  window.removeEventListener('keydown', handleGesture);
  window.removeEventListener('pointerdown', handleGesture);
}

window.addEventListener('keydown', handleGesture);
window.addEventListener('pointerdown', handleGesture);
